import ImageFallback from 'Components/imagefallback'
import Vars from 'Consts/vars'
import { EyeIcon } from '@fdn/icons'
import { CommentArticleIcon } from '@fdn/icons'

const DetailInformation = (props) => {
	return (
		<>
			<div className='detail-information'>
				<div className='detail-information__author'>
					<div className="author-avatar">
						<ImageFallback
							src={props.author_image}
							width={28}
							height={28}
							alt={props.author_name}
							priority={true}
							className="author-image"
							fallbackSrc={Vars.imageBrokenDefault.user}
						/>
					</div>
					<div className="author-name-content">
						<a
							className="username"
							href={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog/author/${props.author_name}`}
						>
							{props.author_name?.toUpperCase()}
						</a>
					</div>
				</div>
				<span className="divider">/</span>
				{props.pageviews && <span className="detail-information__pageviews">
					<EyeIcon size={24} stroke="var(--fd-neutral-7, #637381)" />{' '}
					{props.pageviews}
				</span>}
				<span className="detail-information__comments">
					<CommentArticleIcon size={24} color="var(--fd-neutral-7, #637381)" />{' '}
					{props.comment_count}
				</span>
			</div>
			<style jsx>
				{`
					.detail-information {
						display: flex;
						align-items: center;
						gap: var(--space-16, 16px);
						margin-bottom: 20px;
						width: fit-content;
					}
					.detail-information__author {
						display: flex;
						gap: 16px;
						align-items: center;
					}
					.author-name-content .username {
						color: var(--fd-neutral-7, #637381);
						font-family: "Roboto";
						font-size: 16px;
						font-style: italic;
						font-weight: 700;
						line-height: 20px; 
						text-decoration: none;
					}

					.detail-information__pageviews, 
					.detail-information__comments {
						display: flex;
						align-items: center;
						gap: 4px;

						color: var(--fd-neutral-7, #637381);
						font-family: "Roboto";
						font-size: 14px;
						font-style: normal;
						font-weight: 400;
						line-height: 20px;
					}
					.detail-information__author .author-avatar {
            width: 28px;
            height: 28px;
            border-radius: 50%;
            background-color: #efefef;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow-x: auto;
            flex-shrink: 0;
          }
				`}
			</style>
		</>
	)
}

export default DetailInformation